module.exports = __webpack_public_path__ + "img/30.689c208e.png";